/**
 * useSiteAsset — resolve an editable media value to a renderable URL.
 *
 * Media keys store either a plain URL (the code-side default, served from the
 * CDN) or a `storage://<path>` reference to an operator upload in the private
 * `site-assets` bucket. Uploads are resolved to a signed URL on read.
 */
import { useEffect, useState } from "react";
import { isStorageRef, resolveAssetUrl } from "@/services/site-content";

export function useSiteAsset(value: string): string {
  const [url, setUrl] = useState<string>(() => (isStorageRef(value) ? "" : value));

  useEffect(() => {
    let cancelled = false;
    if (!isStorageRef(value)) {
      setUrl(value);
      return;
    }
    setUrl("");
    resolveAssetUrl(value).then((resolved) => {
      if (!cancelled) setUrl(resolved);
    });
    return () => {
      cancelled = true;
    };
  }, [value]);

  return url;
}
